import React, { lazy } from 'react';
import { ArrowRight, Star, Globe } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function DemosSection() {
  const demos = [{
    title: 'Emergency Electricians Dublin',
    subtitle: 'Electrician Website',
    url: 'https://project-emergency-electricians-dublin-landing-page-582.magicpatterns.app/',
    thumbnail: 'https://image.thum.io/get/width/1200/viewportWidth/1440/wait/3/noanimate/https://project-emergency-electricians-dublin-landing-page-582.magicpatterns.app/',
    gradient: 'from-yellow-900/80 to-amber-900/60'
  }, {
    title: 'Camden Barbers',
    subtitle: 'Barber Website',
    url: 'https://project-camden-barbers-website-475.magicpatterns.app/',
    thumbnail: 'https://image.thum.io/get/width/1200/viewportWidth/1440/wait/3/noanimate/https://project-camden-barbers-website-475.magicpatterns.app/',
    gradient: 'from-gray-800/80 to-gray-900/60'
  }, {
    title: 'Old Mill Restaurant',
    subtitle: 'Restaurant Website',
    url: 'https://project-old-mill-restaurant-website-168.magicpatterns.app/',
    thumbnail: 'https://image.thum.io/get/width/1200/viewportWidth/1440/wait/3/noanimate/https://project-old-mill-restaurant-website-168.magicpatterns.app/',
    gradient: 'from-red-900/80 to-orange-900/60'
  }];
  const testimonials = [{
    name: 'Darren K.',
    role: 'Dublin Emergency Electricians',
    text: 'Emergency calls went up within weeks. The website looks professional and customers trust us instantly when they land on it.'
  }, {
    name: 'Conor M.',
    role: 'Camden Barbers, Dublin 8',
    text: 'Bookings through the website took off straight away. Clients find us on Google and book directly — best investment for the shop.'
  }, {
    name: "Seán O'Brien",
    role: 'The Old Mill, Temple Bar',
    text: 'Table reservations doubled since we launched the new site. It captures the feel of our restaurant perfectly.'
  }];
  return <section id="demos" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-209">
      <div className="max-w-6xl mx-auto" data-id="element-210">
        <div className="text-center mb-6 reveal" data-id="element-211">
          <div className="inline-flex items-center space-x-2 bg-[#c9a84c]/10 border border-[#c9a84c]/30 rounded-full px-4 py-1.5 mb-4" data-id="element-212">
            <Globe className="w-4 h-4 text-[#c9a84c]" data-id="element-213" />
            <span className="text-[#c9a84c] text-sm font-medium" data-id="element-214">
              Demo Websites We Built
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-215">
            Industries We Serve In Ireland
          </h2>
          <p className="text-white/60" data-id="element-216">
            From electricians in Dublin 8 to restaurants in Temple Bar — see
            websites built for real Irish businesses.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-217">
          {demos.map((demo, idx) => <a key={idx} href={demo.url} target="_blank" rel="noopener noreferrer" className="premium-card rounded-xl overflow-hidden group reveal block" style={{
          transitionDelay: `${idx * 100}ms`
        }} data-id="element-218">
              {/* Thumbnail */}
              <div className="relative aspect-[16/10] overflow-hidden rounded-t-xl bg-[#0a0a0a]" data-id="element-219">
                <img src={demo.thumbnail} alt={`${demo.title} - Website Design Dublin`} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" loading="lazy" onError={e => {
              // Fallback to gradient if thumbnail fails
              const target = e.currentTarget;
              target.style.display = 'none';
              const fallback = target.nextElementSibling as HTMLElement;
              if (fallback) fallback.style.display = 'flex';
            }} data-id="element-220" />
                {/* Fallback gradient */}
                <div className={`absolute inset-0 bg-gradient-to-br ${demo.gradient} items-center justify-center hidden`} data-id="element-221">
                  <div className="text-center px-4" data-id="element-222">
                    <Globe className="w-10 h-10 text-[#c9a84c] mx-auto mb-2" data-id="element-223" />
                    <span className="text-xl font-bold text-white drop-shadow-md" data-id="element-224">
                      {demo.title}
                    </span>
                  </div>
                </div>
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors duration-500 flex items-end" data-id="element-225">
                  <div className="p-4 w-full bg-gradient-to-t from-black/80 to-transparent" data-id="element-226">
                    <p className="text-white font-bold text-sm" data-id="element-227">{demo.title}</p>
                    <p className="text-white/60 text-xs" data-id="element-228">{demo.subtitle}</p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="p-5 text-center" style={{
            backgroundColor: '#0a0a0a'
          }} data-id="element-229">
                <span className="inline-flex items-center text-[#c9a84c] font-medium group-hover:underline" data-id="element-230">
                  View Live Demo{' '}
                  <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" data-id="element-231" />
                </span>
              </div>
            </a>)}
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 reveal" data-id="element-232">
          {testimonials.map((t, idx) => <div key={idx} className="border border-white/[0.06] p-6 rounded-xl" style={{
          backgroundColor: '#0a0a0a'
        }} data-id="element-233">
              <div className="flex space-x-1 mb-4" data-id="element-234">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 text-[#c9a84c] fill-[#c9a84c]" data-id="element-235" />)}
              </div>
              <p className="text-white/90 mb-4" data-id="element-236">"{t.text}"</p>
              <div data-id="element-237">
                <p className="text-white font-bold text-sm" data-id="element-238">{t.name}</p>
                <p className="text-white/50 text-xs" data-id="element-239">{t.role}</p>
              </div>
            </div>)}
        </div>
        <p className="text-center text-xs text-white/30 mt-8 reveal" data-id="element-240">
          * Sample testimonials — real reviews coming soon
        </p>
      </div>
      <SectionDivider data-id="element-241" />
    </section>;
}